module.exports = __webpack_public_path__ + "static/media/implementing_fabric_acl_with_cid.169fad38.md";